import React, { useContext, useState } from 'react';
import styles from './Header.module.css';
import logoForDark from './FP Logo files/FP v1 w.png';
import logoForWhite from './FP Logo files/FP v1.png';
import burgerForDark from './menuBurgerForDark.svg';
import burgerForLight from './menuBurgerForLight.svg';
import close from './close.svg';
import sun from './sun.svg';
import moon from './moon.svg';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../../App';
import { useLocation } from 'react-router-dom';

export default function Header() {
  const [isNavMobileOpen, setIsNavMobileOpen] = useState(false);
  const [isSecondNavMobileOpen, setIsSecondNavMobileOpen] = useState(false);

  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleToggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleSecondNav = () => {
    setIsSecondNavMobileOpen(true);
    setIsNavMobileOpen(false);
  };

  const { theme, toggleTheme } = useContext(ThemeContext);

  const location = useLocation();

  const weNeedBorder = () => {
    if (
      theme === 'light' &&
      (location.pathname.includes('/uiDevelopment') ||
        location.pathname.includes('/dataManagement') ||
        location.pathname.includes('/aboutUs'))
    )
      return true;
    return false;
  };

  const closePopUpAndChangeTheme = () => {
    setIsNavMobileOpen(false);
    toggleTheme();
  };

  return (
    <>
      <div
        data-testid={styles[theme]}
        id={styles[theme]}
        className={
          (weNeedBorder() ? styles.whiteBorderBig : '') +
          ' ' +
          styles.headerBlock +
          ' h-vh10 md:h-vh15 lg:h-vh10'
        }
      >
        <div className={styles.leftSide + ' pt-3'}>
          <img
            src={theme === 'dark' ? logoForDark : logoForWhite}
            className="w-1/3 md:w-4/12 lg:w-vw4 p-1"
          ></img>
          {/* <p>FP Technologies</p> */}
        </div>
        <div className={styles.rightSide + ' hidden absolute lg:block'}>
          <Link to="/">Home</Link>
          <Link to="/aboutUs">About us</Link>
          <p
            className={styles.notAlink}
            onMouseEnter={handleToggleMenu}
            onMouseLeave={handleToggleMenu}
          >
            Technical Expertise
            {isMenuOpen && (
              <menu
                className={
                  (weNeedBorder() ? styles.whiteBorderSmall : '') +
                  ' absolute left-0 mt-top-vh-2'
                }
                data-testid="dropdownMenu"
              >
                <ul className="pt-vh3-top">
                  <Link
                    to="/uiDevelopment"
                    className={
                      styles.dropDownItem + ' block mb-bottom-vh2 dropDownItem'
                    }
                  >
                    UI Development
                  </Link>
                  <Link
                    to="/dataManagement"
                    className={
                      styles.dropDownItem + ' block mt-top-vh2 dropDownItem'
                    }
                  >
                    Data Management
                  </Link>
                </ul>
              </menu>
            )}
          </p>
          <Link to="/industryNews">Industy News</Link>

          <Link to="/contactUs">Contact us</Link>
          <img
            src={theme === 'dark' ? moon : sun}
            onClick={toggleTheme}
            className={styles.switcherDesktop}
            data-testid="themeSwitcher"
          />
        </div>

        <div
          className={styles.rightSide + ' flex justify-end relative lg:hidden'}
        >
          <img
            src={theme === 'dark' ? burgerForDark : burgerForLight}
            className="w-1/5"
            onClick={() => setIsNavMobileOpen(true)}
          ></img>
        </div>
      </div>
      <div
        className={
          isNavMobileOpen
            ? 'fixed w-screen h-screen bg-darkTheme z-10 flex items-center flex-col'
            : 'hidden'
        }
      >
        <div
          className="h-vh10 w-full flex justify-end"
          onClick={() => setIsNavMobileOpen(false)}
        >
          <img src={close} className="h-full w-vw10 mr-5" />
        </div>
        <div
          className={
            styles.montserrat +
            ' w-4/5 h-4/5 text-center flex flex-col justify-around md:text-mdSepBtnTxt'
          }
        >
          <Link
            className={styles.montserrat}
            to="/"
            onClick={() => setIsNavMobileOpen(false)}
          >
            HOME
          </Link>
          <Link
            className={styles.montserrat}
            to="/aboutUs"
            onClick={() => setIsNavMobileOpen(false)}
          >
            ABOUT US
          </Link>
          <p className={styles.montserrat} onClick={() => handleSecondNav()}>
            TECHNICAL EXPERTISE
          </p>
          <Link
            className={styles.montserrat}
            to="/industryNews"
            onClick={() => setIsNavMobileOpen(false)}
          >
            INDUSTRY NEWS
          </Link>
          <Link
            className={styles.montserrat}
            to="/contactUs"
            onClick={() => setIsNavMobileOpen(false)}
          >
            CONTACT US
          </Link>
          <p
            className={styles.montserrat}
            onClick={() => closePopUpAndChangeTheme()}
          >
            CHANGE THEME TO {theme === 'dark' ? 'LIGHT' : 'DARK'}
          </p>
        </div>
      </div>

      <div
        className={
          isSecondNavMobileOpen
            ? 'fixed w-screen h-screen bg-darkTheme z-20 flex items-center flex-col'
            : 'hidden'
        }
      >
        <div
          className="h-vh10 w-full flex justify-end"
          onClick={() => setIsSecondNavMobileOpen(false)}
        >
          <img src={close} className="h-full w-vw10 mr-5" />
        </div>
        <div className="w-4/5 h-4/5 text-center flex flex-col justify-around md:text-mdSepBtnTxt">
          <Link
            to="/uiDevelopment"
            className={styles.montserrat}
            onClick={() => setIsSecondNavMobileOpen(false)}
          >
            UI DEVELOPMENT
          </Link>
          <Link
            to="/dataManagement"
            className={styles.montserrat}
            onClick={() => setIsSecondNavMobileOpen(false)}
          >
            DATA MANAGEMENT
          </Link>
        </div>
      </div>
    </>
  );
}
